import { Flex, Image, Title } from "@qws-org/ui-kit";
import type { FC } from "react";

import type { MainBannerV2Props } from "../MainBannerV2";
import { MainBannerButtons } from "./MainBannerButtons";
import { MainBannerRowItems } from "./MainBannerRowItems";

export const Row: FC<MainBannerV2Props> = (props) => {
  const { getImageUrl, data } = props;
  return (
    <Flex
      as="section"
      flexDirection="column"
      align="center"
      justify="center"
      md={{
        p: { py: 40 },
        m: { mx: "auto" },
        minHeight: 580,
        align: "center",
        justify: "space-between",
        flexDirection: "row",
      }}
      m={{ mx: "auto" }}
      p={{ px: 16, pt: 16, pb: 32 }}
      minHeight={500}
      maxWidth={1272}
    >
      <Flex flexDirection="column" className="order-1 flex-grow">
        <Title
          as="h2"
          size="large"
          fontWeight="mobile.superbold"
          horizontalAlign="center"
          bg="text-accent-grad"
          textTransform="uppercase"
          maxWidth={320}
          m={{ mb: 8, mx: "auto" }}
          md={{
            horizontalAlign: "left",
            m: { mb: 32, mx: 0 },
            maxWidth: 610,
          }}
          className="bg-clip-text text-transparent"
        >
          {props.data?.title}
        </Title>
        <MainBannerRowItems {...props} />
        <MainBannerButtons {...props} bannerVariant="row" />
      </Flex>

      {data.image?.id && (
        <Image
          className="md:order-2"
          width="fit-content"
          maxWidth={500}
          m={{ mb: 24 }}
          value={getImageUrl(data.image.id, {
            format: "webp",
            height: 100,
          })}
          mdValue={getImageUrl(data.image.id, {
            format: "webp",
            height: 120,
          })}
          dValue={getImageUrl(data.image.id, {
            format: "webp",
            height: 192,
          })}
        />
      )}
    </Flex>
  );
};
